var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#949090",
    fillOpacity: 0.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6673 17.5676C34.6669 17.9819 34.5021 18.379 34.209 18.6718L26.2173 26.6634C25.9754 26.9053 25.7835 27.1924 25.6526 27.5084C25.5217 27.8244 25.4543 28.1631 25.4543 28.5051C25.4543 28.8471 25.5217 29.1858 25.6526 29.5018C25.7835 29.8178 25.9754 30.1049 26.2173 30.3468L34.1985 38.328C34.4832 38.6227 34.6407 39.0174 34.6371 39.4271C34.6335 39.8368 34.4692 40.2287 34.1795 40.5184C33.8898 40.8081 33.4979 40.9724 33.0882 40.9759C32.6785 40.9795 32.2839 40.822 31.9892 40.5374L24.0079 32.5624C22.9347 31.4871 22.332 30.03 22.332 28.5108C22.332 26.9917 22.9347 25.5345 24.0079 24.4593L31.9996 16.4624C32.2181 16.2437 32.4966 16.0948 32.7998 16.0345C33.103 15.9741 33.4172 16.0051 33.7028 16.1234C33.9884 16.2417 34.2325 16.4421 34.4042 16.6992C34.5759 16.9562 34.6674 17.2585 34.6673 17.5676V17.5676Z",
    fill: "#545353"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.6cf956044d7f671c26e092d868c1900e.svg";
export { ForwardRef as ReactComponent };